export const upyunUpload = '//v0.api.upyun.com/westartrack-file'
